import styled, { css } from 'styled-components';
import { Box, Text } from '@bechtel/gds';

export const StatBlockValueStyled = styled(Text).attrs({
  weight: '600',
  color: 'grey.1000',
})`
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies['graphik']};
    font-size: calc(${theme.spacings[600]} + ${theme.spacings[300]});
  `}
`;

export const StatBlockRowStyled = styled(Box).attrs({
  mr: { sm: '100' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `}
`;

export const StatBlockPriorityStyled = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const StatBlockPriorityInnerStyled = styled(Box).attrs({
  mx: { sm: '200' },
  my: { sm: '200' },
  px: { sm: '400' },
  py: { sm: '200' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    height: calc(${theme.spacings[700]} + ${theme.spacings[300]});
    border-radius: ${theme.spacings[400]};
    background-color: ${theme.colors.grey[100]};
  `}
  width: 100%;
`;

export const StatBlockPriorityIconStyled = styled(Box).attrs({
  px: { sm: '300' },
  py: { sm: '300' },
  mt: { sm: '300' },
})`
  ${({ theme }) => css`
    height: calc(${theme.spacings[500]} + ${theme.spacings[200]})};
    width: calc(${theme.spacings[500]} + ${theme.spacings[200]})};
    background-color: ${theme.colors.red[500]};
    border-radius: ${theme.spacings[200]};
  `}
`;

export const StatBlockPriorityTextStyled = styled(Box).attrs({
  pt: { sm: '300' },
  pl: { sm: '200' },
  mt: { sm: '200' },
})`
  ${({ theme }) => css`
    font-size: calc(${theme.spacings[400]} + ${theme.spacings[200]})};
    color: ${theme.colors.red[500]};
  `}
`;

export const StatBlockPriorityCountStyled = styled(Text).attrs({
  weight: '600',
  color: 'red.500',
})`
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies['graphik']};
    font-size: calc(${theme.spacings[600]} + ${theme.spacings[300]})}
  `}
`;
